import { commonSchema, validateEvent, validateCommon } from '@amzn/aws-d2c-data-layer-schema/dist/1.0/index';
import { DataLayer } from '@amzn/aws-d2c-data-layer';
import { JSONObject } from '@amzn/aws-d2c-data-layer/dist/types';
import CustomConfig from '../configuration/customConfig';

DataLayer.init({
  validateCommon,
  validateEvent: () => true,
  commonSchema,
});

export const updateCommon = (data: JSONObject): void => {
  try {
    DataLayer.updateCommon(sanitizeData(data));
  } catch (e: unknown) {
    console.error(e);
  }
};

export const pushEvent = (data: JSONObject): boolean => {
  try {
    DataLayer.pushEvent(sanitizeData(data));
  } catch (e: unknown) {
    console.error(e);

    return false;
  }

  return true;
};

// If sanitizeData function in the custom config is present,
// updates data using that function.
function sanitizeData(data: JSONObject): JSONObject {
  const sanitize = CustomConfig.config.sanitizeData;

  if (typeof sanitize === 'function') {
    data = sanitize(data);
  }

  return data;
}

// We store these functions in global variables to access them
// inside d2c-client.js which is loaded separately.
window.AWSMA.updateCommonData = (data: JSONObject): void => {
  updateCommon(data);
};

window.AWSMA.pushEventData = (data: JSONObject): void => {
  pushEvent(data);
};
